const DEFAULT_PASTE_CHAR_THRESHOLD = 200;
const PASTE_LINE_THRESHOLD = 30;

const CODE_PATTERNS =
  /\b(function|const|let|var|import|export|class|def|return|if|for|while|switch|try|catch|async|await|interface|type|enum)\b/;

export function shouldConvertPasteToFile(
  pastedText: string,
  existingContent: string,
  maxLength: number,
  charThreshold: number = DEFAULT_PASTE_CHAR_THRESHOLD,
): boolean {
  if (pastedText.length >= charThreshold) return true;
  if (pastedText.split('\n').length >= PASTE_LINE_THRESHOLD) return true;
  if (existingContent.length + pastedText.length > maxLength) return true;
  return false;
}

function generatePasteFilename(text: string): string {
  const now = new Date();
  const pad = (n: number) => String(n).padStart(2, '0');
  const timestamp = `${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(now.getDate())}-${pad(now.getHours())}${pad(now.getMinutes())}${pad(now.getSeconds())}`;
  const prefix = CODE_PATTERNS.test(text) ? 'код' : 'поставен-текст';
  return `${prefix}-${timestamp}.txt`;
}

export function createTextFileFromPaste(text: string): File {
  const blob = new Blob([text], { type: 'text/plain;charset=utf-8' });
  const filename = generatePasteFilename(text);
  return new File([blob], filename, { type: 'text/plain' });
}
